import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { ModulesName } from '../../definitions';
import { APPLICATION_ROUTES } from '../../route';

export function setupTechnicalVisit(): void {
  applicationModuleRegistry.register({
    entry: ModulesName.TECHNICAL_VISIT,
    id: ModulesName.TECHNICAL_VISIT,
    name: 'hi.technical-visit',
    route: APPLICATION_ROUTES.TECHNICAL_VISIT,
  });
}
